<template>
    <div class="trips container" :class="!user ? 'not-logged' : ''">
        <!-- Hero Section -->
        <div class="hero-section">
            <div class="hero-overlay"></div>
            <div class="hero-content">
                <h1 class="hero-title">Trouvez votre prochain covoiturage</h1>
                <h2 class="hero-subtitle">Sans commission</h2>
                <p class="hero-text">
                    MyEcoCar est une plateforme innovatrice basée sur une mise en relation sans commission. 
                    Les frais de trajet seront directement payés par le passager au conducteur
                </p>
                
                <!-- SearchBox intégré dans le hero -->
                <div class="hero-search-wrapper" v-show="!isMobile || lookSearch">
                    <SearchBox
                        :params="searchParams"
                        v-on:trip-search="research"
                        ref="searchBox"
                    ></SearchBox>
                </div>
            </div>
        </div>
        
        <div v-show="!user && isMobile">
            <router-link :to="{ name: 'login' }" class="login_usuario">
                {{ $t('ingresaORegistrate') }}
                <span class="underline">{{ $t('aqui') }}</span>
                {{ $t('paraComenzar') }}
            </router-link>
        </div>
        <Loading :data="trips" v-if="showingTrips">
            <div class="trips-list row">                
                <modal
                    :name="'modal'"
                    v-if="showModal"
                    @close="showModal = false"
                    :title="'Test'"
                    :body="'Body'"
                >
                    <template #header><h3>
                        <span>{{ $t('donaA') }}</span>
                        <br class="hidden-sm hidden-md hidden-lg" />
                        <small>{{ $t('proyectoDe') }}</small>
                        <img
                            width="90"
                            alt="STS Rosario"
                            src="https://carpoolear.com.ar/img/logo_sts_nuevo_color.png"
                        />
                    </h3></template>
                    <template #body><div class="donation">
                        <div class="radio">
                            <label class="radio-inline">
                                <input
                                    type="radio"
                                    name="donationValor"
                                    id="donation50"
                                    value="2000"
                                    v-model="donateValue"
                                />
                                <span>$ 2000</span>
                            </label>
                            <label class="radio-inline">
                                <input
                                    type="radio"
                                    name="donationValor"
                                    id="donation100"
                                    value="5000"
                                    v-model="donateValue"
                                />
                                <span>$ 5000</span>
                            </label>
                            <label class="radio-inline">
                                <input
                                    type="radio"
                                    name="donationValor"
                                    id="donation200"
                                    value="10000"
                                    v-model="donateValue"
                                />
                                <span>$ 10000</span>
                            </label>
                            <label class="radio-inline">
                                <input
                                    type="radio"
                                    name="donationValor"
                                    id="donation500"
                                    value="50"
                                    v-model="donateValue"
                                />
                                <span
                                    >{{ $t('elegirPropiaAventuraSoloMensual') }}</span
                                >
                            </label>
                        </div>
                        <div>
                            <button
                                class="btn btn-success btn-unica-vez"
                                @click="onDonateOnceTime"
                            >
                                {{ $t('unicaVez') }}
                            </button>
                            <button
                                class="btn btn-info btn-mensualmente"
                                @click="onDonateMonthly"
                            >
                                {{ $t('MENSUAL') }}
                                <br />
                                ( {{ $t('cancelaCuando') }})
                            </button>
                        </div>
                    </div></template>
                </modal>
                <modal
                    :name="'modal'"
                    v-if="showModalInstallApp && shouldShowInstallModal()"
                    @close="closeInstallModal()"
                    :title="'Test'"
                    :body="'Body'"
                >
                    <template #header><h3>
                        <span>{{ getInstallModalContent() && getInstallModalContent().title || $t('instalarApp') }}</span>
                    </h3></template>
                    <template #body><div class="">
                        <p style="white-space: pre-line;" v-html="getInstallModalContent() && getInstallModalContent().message || $t('instalarWebAppPWA')">
                        </p>
                        <div style="margin-bottom: 10px">
                            <button
                                v-if="getInstallModalContent() && getInstallModalContent().showInstallButton"
                                class="btn btn-danger"
                                @click="installApp()"
                            >
                                {{ $t('instalar') }}
                            </button>
                            <button
                                v-if="getInstallModalContent() && getInstallModalContent().showCloseButton"
                                class="btn btn-primary"
                                @click="closeInstallModal()"
                            >
                                {{ $t('entendido') }}
                            </button>
                            <button
                                v-if="getInstallModalContent() && getInstallModalContent().showDontShowAgainButton"
                                class="btn btn-default"
                                @click="dontShowAgainInstallModal()"
                                style="margin-left: 10px;"
                            >
                                {{ $t('noMostrarDeNuevo') }}
                            </button>
                        </div>
                    </div></template>
                </modal>
                <template v-for="(trip, index) in limitedTrips">
                    <template
                        v-if="
                            isDonationTime() &&
                            (!user || !user.monthly_donate) &&
                            !shouldHideDonationOnIOSCapacitor(user)
                        "
                    >
                        <!-- solo si el usuario no es donador mensual -->
                        <div
                            class="panel panel-default panel-donar"
                            v-if="
                                (index +
                                    parseFloat(
                                        appConfig.donation.trips_offset
                                    )) %
                                    parseFloat(
                                        appConfig.donation.trips_count
                                    ) ===
                                0
                            "
                        >
                            <div class="panel-body">
                                <button
                                    class="btn btn-success pull-right btn-donar"
                                    @click="onDonate"
                                >
                                    {{ $t('donar') }}
                                </button>
                                <h2>{{ $t('ayudanos') }}</h2>

                                <a
                                    href="/donar"
                                    target="_blank"
                                    v-on:click.prevent="
                                        onOpenLink(
                                            'https://carpoolear.com.ar/donar?u=' +
                                                user.id
                                        )
                                    "
                                >
                                    {{ $t('porQueDonar') }}
                                </a>
                            </div>
                        </div>
                    </template>
                    <template v-if="isComplementary(trip, searchParams, index)">
                        <div class="trip-complementary">
                            <h2>{{ $t('resultadosCercanos') }}</h2>
                        </div>
                    </template>
                    <Trip :trip="trip" :user="user"></Trip>
                </template>
            </div>
            
            <!-- Boutons pour voir tous les trajets et toutes les demandes -->
            <div class="row" v-if="trips.length >= 3">
                <div class="text-center" style="margin: 30px 0;">
                    <button 
                        class="btn btn-primary btn-lg" 
                        @click="goToAllTrips"
                        style="padding: 12px 40px; font-size: 16px; border-radius: 25px; margin-right: 15px;"
                    >
                        <i class="fa fa-road" aria-hidden="true"></i>
                        Tous les trajets
                    </button>
                    <button 
                        class="btn btn-primary btn-lg" 
                        @click="goToAllRequests"
                        style="padding: 12px 40px; font-size: 16px; border-radius: 25px;"
                    >
                        <i class="fa fa-users" aria-hidden="true"></i>
                        Toutes les demandes
                    </button>
                </div>
            </div>
            
            <div class="row">
                <p
                    class="alert alert-warning"
                    role="alert"
                    :class="isMobile ? 'mobile-alert' : ''"
                    v-if="resultaOfSearch && !alreadySubscribe"
                >
                    <span class="sentence">
                        <strong :class="isMobile ? 'sentence' : ''">
                            {{ $t('podesSubscribirte') }}
                        </strong>
                        <button
                            class="btn btn-primary"
                            v-if="user"
                            @click="subscribeSearch"
                        >
                            {{ $t('crearAlerta') }}
                        </button>
                    </span>
                </p>
            </div>
            <div v-if="runningSearch" class="more-trips-loading">
                <img
                    src="https://carpoolear.com.ar/static/img/loader.gif"
                    alt=""
                    class="ajax-loader"
                />
                {{ $t('cargandoMasResultados') }}
            </div>
            <template #no-data>
                <p
                    class="alert alert-warning"
                    role="alert"
                    :class="isMobile ? 'mobile-alert' : ''"
                >
                    <template v-if="filtered">
                        <span class="sentence">{{ $t('noHayViajes') }}</span>
                        <span class="sentence" v-if="!alreadySubscribe">
                            <strong :class="isMobile ? 'sentence' : ''">
                                {{ $t('subscribirteAViajes') }}
                            </strong>
                            <button
                                class="btn btn-primary"
                                v-if="user"
                                @click="subscribeSearch"
                            >
                                {{ $t('crearAlerta') }}
                            </button>
                        </span>
                    </template>
                    <template v-else>
                        <span class="sentence">{{
                            $t('noHayViajesCargadosAun')
                        }}</span>
                    </template>
                </p>
            </template>
            <template #loading><p class="alert alert-info" role="alert">
                <img
                    src="https://carpoolear.com.ar/static/img/loader.gif"
                    alt=""
                    class="ajax-loader"
                />
                {{ $t('cargandoViajes') }}
            </p></template>
        </Loading>

        <!-- Section Comment ça marche -->
        <div class="how-it-works-section">
            <h2 class="how-it-works-title">Comment ça marche ?</h2>
            <p class="how-it-works-subtitle">
                Simple, rapide et écologique. Commencez le covoiturage dès aujourd'hui.
            </p>
            
            <div class="how-it-works-cards">
                <!-- Card Écologique -->
                <div class="how-card">
                    <div class="how-card-icon green-icon">
                        <i class="fa fa-leaf" aria-hidden="true"></i>
                    </div>
                    <h3 class="how-card-title">Écologique</h3>
                    <p class="how-card-description">
                        Réduisez votre empreinte carbone en partageant vos trajets. Chaque kilomètre partagé aide la planète.
                    </p>
                </div>

                <!-- Card Économique -->
                <div class="how-card">
                    <div class="how-card-icon green-icon">
                        <i class="fa fa-car" aria-hidden="true"></i>
                    </div>
                    <h3 class="how-card-title">Économique</h3>
                    <p class="how-card-description">
                        Économisez de l'argent sur l'essence et les péages en partageant les frais avec d'autres passagers.
                    </p>
                </div>

                <!-- Card Communauté -->
                <div class="how-card">
                    <div class="how-card-icon green-icon">
                        <i class="fa fa-users" aria-hidden="true"></i>
                    </div>
                    <h3 class="how-card-title">Communauté</h3>
                    <p class="how-card-description">
                        Rencontrez de nouvelles personnes et faites partie d'une communauté de voyageurs éco-conscients.
                    </p>
                </div>
            </div>
        </div>

        <!-- Section Pourquoi choisir MyEcoCar -->
        <div class="why-choose-section">
            <h2 class="why-choose-title">Pourquoi choisir MyEcoCar ?</h2>
            <p class="why-choose-subtitle">
                Nous offrons une expérience de covoiturage fiable, abordable et conviviale.
            </p>

            <div class="why-choose-row">
                <div class="why-choose-image-col">
                    <img
                        class="why-choose-image"
                        src="https://i.imgur.com/LAi60ZD.png"
                        alt="Passageres dans une voiture de covoiturage"
                    />
                </div>

                <div class="why-choose-content-col">
                    <div class="feature-item">
                        <div class="feature-icon"><i class="fa fa-car" aria-hidden="true"></i></div>
                        <div class="feature-text">
                            <h3 class="feature-title">Covoiturage régulier</h3>
                            <p class="feature-description">
                                Publiez vos trajets de covoiturages réguliers, domicile-travail. Le covoiturage permet de diminuer les frais, de couper avec la monotonie du trajet en voiture lorsque l'on est au volant. C'est une occasion de convivialité et de partage.
                            </p>
                        </div>
                    </div>

                    <div class="feature-item">
                        <div class="feature-icon"><i class="fa fa-female" aria-hidden="true"></i></div>
                        <div class="feature-text">
                            <h3 class="feature-title">Covoiturage entre femmes</h3>
                            <p class="feature-description">
                                Pour plus de sérénité, MyEcoCar propose une option de covoiturage réservée aux femmes. Recherchez ou proposez facilement des trajets exclusivement entre femmes pour voyager en toute confiance et sécurité.
                            </p>
                        </div>
                    </div>

                    <div class="feature-item">
                        <div class="feature-icon"><i class="fa fa-user" aria-hidden="true"></i></div>
                        <div class="feature-text">
                            <h3 class="feature-title">Passagers</h3>
                            <p class="feature-description">
                                Vous n'avez pas trouvé de covoiturage ? Publiez votre demande en quelques clics. Notre plateforme soutient l'économie collaborative : sans commission, avec un paiement direct au conducteur. C'est simple, sécurisé et innovant.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Section Nos Partenaires -->
        <div class="partners-section">
            <h2 class="partners-title">Nos Partenaires</h2>
            <p class="partners-subtitle">
                Ils nous font confiance pour une mobilité durable et responsable
            </p>
            
            <div class="partners-grid">
                <div class="partner-item">
                    <div class="partner-placeholder">
                        <i class="fa fa-building" aria-hidden="true"></i>
                        <span>Partenaire 1</span>
                    </div>
                </div>
                <div class="partner-item">
                    <div class="partner-placeholder">
                        <i class="fa fa-building" aria-hidden="true"></i>
                        <span>Partenaire 2</span>
                    </div>
                </div>
                <div class="partner-item">
                    <div class="partner-placeholder">
                        <i class="fa fa-building" aria-hidden="true"></i>
                        <span>Partenaire 3</span>
                    </div>
                </div>
                <div class="partner-item">
                    <div class="partner-placeholder">
                        <i class="fa fa-building" aria-hidden="true"></i>
                        <span>Partenaire 4</span>
                    </div>
                </div>
                <div class="partner-item">
                    <div class="partner-placeholder">
                        <i class="fa fa-building" aria-hidden="true"></i>
                        <span>Partenaire 5</span>
                    </div>
                </div>
                <div class="partner-item">
                    <div class="partner-placeholder">
                        <i class="fa fa-building" aria-hidden="true"></i>
                        <span>Partenaire 6</span>
                    </div>
                </div>
                <div class="partner-item">
                    <div class="partner-placeholder">
                        <i class="fa fa-building" aria-hidden="true"></i>
                        <span>Partenaire 7</span>
                    </div>
                </div>
                <div class="partner-item">
                    <div class="partner-placeholder">
                        <i class="fa fa-building" aria-hidden="true"></i>
                        <span>Partenaire 8</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Section Footer -->
        <footer class="footer-section">
            <div class="footer-container">
                <div class="footer-left">
                    <div class="footer-logo-section">
                        <img src="https://i.imgur.com/z198fac.png" alt="MyEcoCar Logo" class="footer-logo" />
                        <span class="footer-brand-name">MyEcoCar</span>
                    </div>
                    <div class="footer-social-links">
                        <a href="#" class="social-link" title="Facebook">
                            <i class="fa fa-facebook-f"></i>
                        </a>
                        <a href="#" class="social-link" title="Twitter">
                            <i class="fa fa-twitter"></i>
                        </a>
                        <a href="#" class="social-link" title="Instagram">
                            <i class="fa fa-instagram"></i>
                        </a>
                        <a href="#" class="social-link" title="LinkedIn">
                            <i class="fa fa-linkedin"></i>
                        </a>
                    </div>
                </div>

                <div class="footer-center">
                    <div class="footer-column">
                        <h4 class="footer-column-title">Infos</h4>
                        <ul class="footer-links">
                            <li><router-link :to="{ name: 'cgu' }">CGU</router-link></li>
                            <li><router-link :to="{ name: 'faq' }">FAQ</router-link></li>
                            <li><router-link :to="{ name: 'contact' }">Contact</router-link></li>
                        </ul>
                    </div>

                    <div class="footer-column">
                        <h4 class="footer-column-title">Découvrir</h4>
                        <ul class="footer-links">
                            <li><router-link :to="{ name: 'about' }">Qui sommes-nous ?</router-link></li>
                            <li><router-link :to="{ name: 'conduct-charter' }">Charte de bonne conduite</router-link></li>
                            <li><router-link :to="{ name: 'map' }">Carte Interactive</router-link></li>
                        </ul>
                    </div>

                    <div class="footer-column">
                        <h4 class="footer-column-title">Plus</h4>
                        <ul class="footer-links">
                            <li><router-link :to="{ name: 'concept' }">Notre Concept</router-link></li>
                            <li><router-link :to="{ name: 'cookies' }">Utilisation des cookies</router-link></li>
                            <li><router-link :to="{ name: 'sitemap' }">Plan du site</router-link></li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="footer-bottom">
                <p class="footer-copyright">
                    &copy; {{ new Date().getFullYear() }} MyEcoCar. Tous les droits réservés.
                </p>
            </div>
        </footer>
    </div>
</template>
<style scoped>
.sentence {
    display: block;
    margin-bottom: 0.5em;
}

.mobile-alert .sentence {
    margin-bottom: 1em;
}

.mobile-alert .btn {
    margin: 0 auto;
    display: block;
}
</style>
<script>
import Trip from '../sections/Trip.vue';
import SearchBox from '../sections/SearchTrip.vue';
import Loading from '../Loading.vue';
import bus from '../../services/bus-event.js';
import { mapGetters, mapActions } from 'vuex';
import dayjs from '../../dayjs';
import router from '../../router';
import dialogs from '../../services/dialogs.js';
import modal from '../Modal';
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import {
    isIOSCapacitor,
    shouldHideDonationOnIOSCapacitor
} from '../../services/capacitor.js';

export default {
    name: 'trips',
    data() {
        return {
            lookSearch: false,
            filtered: false,
            runningSearch: false,
            alreadySubscribe: false,
            resultaOfSearch: false,
            showModal: false,
            showModalInstallApp: false,
            installAppEvent: null,
            donateValue: 0,
            hasNotificationPermission: false,
            showNotificationWarning: true
        };
    },
    props: ['clearSearch', 'keepSearch'],
    methods: {
        ...mapActions({
            search: 'trips/tripsSearch',
            refreshTrips: 'trips/refreshList',
            subscribeToSearch: 'subscriptions/create',
            findSubscriptions: 'subscriptions/index',
            registerDonation: 'profile/registerDonation',
            setScrollOffset: 'trips/setScrollOffset'
            // morePagesActions: 'trips/tripMorePage',
            // setActionButton: 'actionbars/setHeaderButtons'
        }),
        isIOS() {
            return /iphone|ipad|ipod/.test(window.navigator.userAgent.toLowerCase());
        },
        isSafari() {
            const userAgent = window.navigator.userAgent.toLowerCase();
            return /iphone|ipad|ipod/.test(userAgent) && /safari/.test(userAgent) && !/chrome/.test(userAgent);
        },
        isPWA() {
            // Check if running as PWA (standalone mode)
            return window.navigator.standalone === true || 
                   window.matchMedia('(display-mode: standalone)').matches ||
                   window.matchMedia('(display-mode: window-controls-overlay)').matches;
        },
        shouldShowInstallModal() {
            // Show modal if we have install event (Android) or if we're on iOS
            return this.installAppEvent !== null || this.isIOS();
        },
        getInstallModalContent() {
            if (this.installAppEvent !== null) {
                // Android - show install button
                return {
                    title: $t('instalarApp'),
                    message: $t('instalarWebAppPWA'),
                    showInstallButton: true,
                    showCloseButton: false,
                    showDontShowAgainButton: true
                };
            } else if (this.isIOS()) {
                // iOS - show installation instructions
                return {
                    title: $t('instalarAppEnIos'),
                    message: $t('instalarAppEnIosInstrucciones'),
                    showInstallButton: false,
                    showCloseButton: true,
                    showDontShowAgainButton: true
                };
            }
            return null;
        },
        isDonationTime() {
            if (this.appConfig) {
                return (
                    dayjs().date() <
                    parseFloat(this.appConfig.donation.month_days)
                );
            } else {
                return false;
            }
        },
        shouldHideDonationOnIOSCapacitor(user) {
            return shouldHideDonationOnIOSCapacitor(user);
        },
        async installApp() {
            this.showModalInstallApp = false;
            if (this.installAppEvent !== null) {
                this.installAppEvent.prompt();
                // Espera a que el usuario responda al mensaje
                const { outcome } = await this.installAppEvent.userChoice;
                // {{ $t('esperaUsuarioResponda') }}
            }
        },
        closeInstallModal() {
            this.showModalInstallApp = false;
            // For iOS, this just closes temporarily - no localStorage flag
        },
        dontShowAgainInstallModal() {
            this.showModalInstallApp = false;
            // Mark that we've shown the install modal to this user permanently
            localStorage.setItem('pwa_install_modal_dismissed', 'true');
        },
        research(params) {
            this.resultaOfSearch = true;
            this.lookSearch = false;
            this.filtered = true;
            this.readySub = false;
            this.alreadySubscribe = false;
            this.search(params);
            this.findSubscriptions();
            // this.setActionButton(['clear']);
        },
        nextPage() {
            this.search({ next: true });
        },
        onTripClick() {
            let scrolloffset = window.scrollY;
            this.setScrollOffset(scrolloffset);
        },
        isComplementary(trip, searchParams, index) {
            let isComplementary = false;
            if (searchParams.data && searchParams.data.date) {
                var searchDate = dayjs(searchParams.data.date).toDate();
                var tripDate = dayjs(trip.trip_date).toDate();
                tripDate.setHours(0);
                tripDate.setMinutes(0);
                tripDate.setSeconds(0);
                if (searchDate.getTime() === tripDate.getTime()) {
                    isComplementary = false;
                } else {
                    isComplementary = true;
                }
            }
            return isComplementary;
        },
        // TODO filter trips that not are main route
        // REVIEW wich is the best way to do it?
        // maybe rethink render
        isMainRoute(trip, searchParams, index) {
            let isMainRoute = true;
            if (
                searchParams.data &&
                (searchParams.data.destination_id ||
                    searchParams.data.origin_id)
            ) {
                // trip.points[i].json_address.id
                if (trip.points && trip.points.length) {
                }
            }
            return isMainRoute;
        },

        onSearchButton() {
            console.log('onSearchButton');
            this.lookSearch = true;
            // this.setActionButton(['clear']);
            bus.on('backbutton', this.onBackBottom);
            // Desactivo reaccionar al Scroll
        },

        onClearButton() {
            bus.off('backbutton', this.onBackBottom);
            bus.on('scroll-bottom', this.onScrollBottom);
            // this.setActionButton(['search']);
            this.filtered = false;
            this.lookSearch = false;
            this.alreadySubscribe = false;
            this.search({ is_passenger: false });
            if (this.$refs.searchBox) {
                this.$refs.searchBox.clear();
            }
        },
        onScrollBottom() {
            // ⚠️ DÉSACTIVÉ sur /trips : Pas de scroll infini, limite stricte de 3 cards
            // Le scroll infini est réservé à /trips/all
            // Si plus de 3 trajets disponibles, l'utilisateur doit cliquer sur "Tous les trajets"
            return;
            
            /* Code original désactivé
            if (this.morePages && !this.lookSearch) {
                // Hay páginas y no estoy en búsquedas;
                if (!this.runningSearch) {
                    this.runningSearch = true;
                    let done = () => {
                        this.runningSearch = false;
                    };
                    this.search({ next: true }).then(done, done);
                }
            }
            */
        },
        onBackBottom() {
            bus.off('backbutton', this.onBackBottom);
            this.lookSearch = false;
            this.alreadySubscribe = false;
        },
        async onDonate() {
            // if we're in Capacitor iOS, do not show the modal, just open the link in the browser
            if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios') {
                let url = 'https://carpoolear.com.ar/donar';
                if (this.user && this.user.id) {
                    url = `${url}?u=${this.user.id}`;
                }
                await this.openExternalBrowser(url);
                return;
            }
            this.showModal = true;
        },
        async openExternalBrowser(url) {
            // On iOS Capacitor, use App.openUrl() to open in external browser (Safari)
            // This makes the user leave the app, which is required for donations
            if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios') {
                try {
                    await App.openUrl({ url });
                } catch (error) {
                    console.error('Error opening URL in external browser:', error);
                    // Fallback to window.open if App.openUrl fails
                    window.open(url, '_blank');
                }
            } else {
                // For web or Android, use window.open
                window.open(url, '_blank');
            }
        },
        onOpenLink(link) {
            this.openExternalBrowser(link);
        },
        async onDonateOnceTime() {
            if (this.donateValue > 0) {
                var url = 'http://mpago.la/jgap'; // 50
                switch (this.donateValue) {
                    case '2000':
                        url =
                            'https://mpago.la/1WhaoLf';
                        break;
                    case '5000':
                        url =
                            'https://mpago.la/1SB6on8';
                        break;
                    case '10000':
                        url =
                            'https://mpago.la/2USgEBv';
                        break;
                    default:
                        url = 'https://mpago.la/jgap';
                        break;
                }
                // Add userId parameter for tracking
                if (this.user && this.user.id) {
                    const separator = url.includes('?') ? '&' : '?';
                    url = `${url}${separator}u=${this.user.id}`;
                }
                // Open in external browser (required for iOS donations)
                await this.openExternalBrowser(url);
                this.showModal = false;
                let data = {
                    has_donated: 1,
                    has_denied: 0,
                    ammount: parseFloat(this.donateValue)
                };
                this.registerDonation(data);
            } else {
                dialogs.message(this.$t('valorDonacion'), {
                    duration: 10,
                    estado: 'error'
                });
            }
        },
        async onDonateMonthly() {
            if (this.donateValue >= 0) {
                var url = 'http://mpago.la/2XdoxpF'; // 50
                switch (this.donateValue) {
                    case '2000':
                        url = 'https://www.mercadopago.com.ar/subscriptions/checkout?preapproval_plan_id=2c9380848a2fd5c9018a33702cc50181';
                        break;
                    case '5000':
                        url = 'https://www.mercadopago.com.ar/subscriptions/checkout?preapproval_plan_id=2c9380848cee0ea5018d0e9ea71016d7';
                        break;
                    case '10000':
                        url = 'https://www.mercadopago.com.ar/subscriptions/checkout?preapproval_plan_id=2c93808497030fc7019705478b370068';
                        break;
                    default:
                        break;
                }
                // Add userId parameter for tracking
                if (this.user && this.user.id) {
                    const separator = url.includes('?') ? '&' : '?';
                    url = `${url}${separator}u=${this.user.id}`;
                }
                // Open in external browser (required for iOS donations)
                await this.openExternalBrowser(url);
                this.showModal = false;
                let data = {
                    has_donated: 1,
                    has_denied: 0,
                    ammount: parseFloat(this.donateValue)
                };
                this.registerDonation(data);
            } else {
                dialogs.message(this.$t('valorDonacion'), {
                    duration: 10,
                    estado: 'error'
                });
            }
        },
        goToAllTrips() {
            this.$router.push({ name: 'all-trips' });
        },
        goToAllRequests() {
            this.$router.push({ name: 'all-requests' });
        },
        subscribeSearch() {
            let params = this.searchParams.data;
            let data = {};
            if (params.date) {
                data.trip_date = params.date;
            }
            if (params.origin_name) {
                data.from_address = params.origin_name;
                data.from_lat = params.origin_lat;
                data.from_lng = params.origin_lng;
                data.from_radio = params.origin_radio;
                data.from_id = params.origin_id;
                data.from_json_address = [];
            }
            if (params.destination_name) {
                data.to_address = params.destination_name;
                data.to_lat = params.destination_lat;
                data.to_lng = params.destination_lng;
                data.to_radio = params.destination_radio;
                data.to_id = params.destination_id;
                data.to_json_address = [];
            }

            data.is_passenger = params.is_passenger;

            this.subscribeToSearch(data)
                .then(() => {
                    this.alreadySubscribe = true;
                    dialogs.message(this.$t('correctamenteSubscripto'), {
                        duration: 10,
                        estado: 'success'
                    });
                })
                .catch((response) => {
                    console.log(response);
                    if (response.data.errors && response.data.errors.error) {
                        if (
                            response.data.errors.error[0] ===
                            'subscription_exist'
                        ) {
                            dialogs.message(this.$t('yaTienesSubscripcion'), {
                                duration: 10,
                                estado: 'error'
                            });
                        }
                    }
                });
        },
    },
    mounted() {
        // Clear search
        if (this.clearSearch) {
            this.onClearButton();
        } else {
            // Tendria que recargar desde la búsqueda anterior
            if (this.$refs.searchBox) {
                this.$refs.searchBox.loadParams(this.searchParams.data);
            }
        }
        if (!this.keepSearch) {
            this.$refs.searchBox.clear();
        }

        if (this.scrollPosition) {
            this.$nextTick(() => {
                setTimeout(() => {
                    window.scrollTo(0, this.scrollPosition);
                }, 2);
            });
        }

        window.addEventListener('beforeinstallprompt', (e) => {
            // {{ $t('previeneMiniBarraInformacion') }}
            e.preventDefault();
            // {{ $t('guardaEventoDispareMasTarde') }}
            this.installAppEvent = e;
            
            // Check if user has permanently dismissed the install modal
            const hasDismissedInstallModal = localStorage.getItem('pwa_install_modal_dismissed');
            if (!hasDismissedInstallModal) {
                // {{ $t('actualizarIUNotificarUsuario') }}
                this.showModalInstallApp = true;
            }
            // De manera opcional, envía el evento de analíticos para saber si se mostró la promoción a a instalación del PWA
            console.log(`'beforeinstallprompt' event was fired.`);
        });

        // Show install modal for iOS users (since beforeinstallprompt doesn't fire on iOS)
        if (this.isIOS()) {
            // Check if user hasn't permanently dismissed this before
            const hasDismissedInstallModal = localStorage.getItem('pwa_install_modal_dismissed');
            if (!hasDismissedInstallModal) {
                // Show modal after a short delay to ensure the page is loaded
                setTimeout(() => {
                    this.showModalInstallApp = true;
                }, 2000);
            }
        }
        
        // bus.event
        bus.off('search-click', this.onSearchButton);
        bus.on('search-click', this.onSearchButton);
        bus.off('clear-click', this.onClearButton);
        bus.on('clear-click', this.onClearButton);
        bus.off('scroll-bottom', this.onScrollBottom);
        bus.on('scroll-bottom', this.onScrollBottom);
        bus.off('trip-click', this.onTripClick);
        bus.on('trip-click', this.onTripClick);

        router.stack = [];
    },
    updated(a) {
        // {{ $t('pendienteNoSeLimpiaBuscador') }}
    },
    beforeDestroy() {
        bus.off('search-click', this.onSearchButton);
        bus.off('clear-click', this.onClearButton);
        bus.off('scroll-bottom', this.onScrollBottom);
        bus.off('backbutton', this.onBackBottom);
    },
    watch: {
        trips: function (oldValue, newValue) {
            if (this.refreshList) {
                this.refreshTrips(false);
                this.lookSearch = false;
                this.resultaOfSearch = false;
                this.$refs.searchBox.clear();
            }
        }
    },
    computed: {
        ...mapGetters({
            trips: 'trips/trips',
            morePages: 'trips/tripsMorePage',
            user: 'auth/user',
            searchParams: 'trips/tripsSearchParam',
            isMobile: 'device/isMobile',
            isBrowser: 'device/isBrowser',
            refreshList: 'trips/refreshList',
            subscriptions: 'subscriptions/subscriptions',
            appConfig: 'auth/appConfig',
            scrollPosition: 'trips/scrollOffset'
        }),

        showingTrips() {
            return !this.isMobile || !this.lookSearch;
        },
        isIOSCapacitor() {
            return Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios';
        },
        limitedTrips() {
            // ⚠️ RÈGLE STRICTE : Toujours limiter à 6 trajets maximum sur /trips
            // Peu importe si c'est une recherche, un filtre, ou l'affichage par défaut
            // Le bouton "Tous les trajets" redirige vers /trips/all pour voir plus
            return this.trips.slice(0, 6);
        }
    },
    components: {
        Trip,
        Loading,
        SearchBox,
        modal
    }
};
</script>
<style>
/* Styles non-scoped pour neutraliser TOUS les espaces en bas de page sur la vue Trips */

/* Supprimer marges/paddings de body et html */
body {
    margin: 0 !important;
    padding: 0 !important;
    margin-bottom: 0 !important;
    padding-bottom: 0 !important;
}

html {
    margin: 0 !important;
    padding: 0 !important;
    margin-bottom: 0 !important;
    padding-bottom: 0 !important;
}

/* Neutraliser les min-height qui créent de l'espace vide sur la page Trips */
.app-container.trips,
.app-container.trips main,
.app-container.trips #main {
    min-height: 0 !important;
    margin-bottom: 0 !important;
    padding-bottom: 0 !important;
}

.app-container.trips .view-container {
    padding-bottom: 0 !important;
    margin-bottom: 0 !important;
}

/* IMPORTANT : Cacher le footer global (FooterApp) sur la page Trips car on a notre propre footer */
.app-container.trips .footer-component {
    display: none !important;
}
</style>

<style scoped>
.trips,
.trips.container {
    margin-top: 0 !important;
    padding-top: 0 !important;
    margin-bottom: 0 !important;
    padding-bottom: 0 !important;
}

/* === FORCER 3 CARTES PAR LIGNE === */
.trips-list.row {
    display: flex;
    flex-wrap: wrap;
    margin-left: -15px;
    margin-right: -15px;
}

/* Forcer explicitement 3 colonnes sur grand écran */
.trips-list.row > div[class*="col-"] {
    flex: 0 0 33.333333% !important;
    max-width: 33.333333% !important;
    padding-left: 15px;
    padding-right: 15px;
    margin-bottom: 30px;
}

/* 2 colonnes sur tablette */
@media (max-width: 1199px) {
    .trips-list.row > div[class*="col-"] {
        flex: 0 0 50% !important;
        max-width: 50% !important;
    }
}

/* 1 colonne sur mobile */
@media (max-width: 767px) {
    .trips-list.row > div[class*="col-"] {
        flex: 0 0 100% !important;
        max-width: 100% !important;
    }
}
/* === FIN FORCER 3 CARTES PAR LIGNE === */

/* Hero Section */
.hero-section {
    position: relative;
    width: 100vw;
    height: 900px;
    margin-left: calc(-50vw + 50%);
    margin-top: -70px;
    margin-bottom: 2em;
    background-image: url('../../assets/header-img.jpeg');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    overflow: visible;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.hero-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(10, 10, 10, 0.53);
    z-index: 1;
}

.hero-content {
    position: relative;
    z-index: 2;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    padding: 40px 20px;
    text-align: center;
    color: white;
}

.hero-title {
    font-family: 'Poppins', sans-serif;
    font-size: 48px;
    font-weight: 600;
    color: white;
    margin: 0 0 15px 0;
    text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.3);
    line-height: 1.2;
}

.hero-subtitle {
    font-family:  'Poppins', sans-serif;
    font-size: 32px;
    font-weight: 900;
    margin: 0 0 25px 0;
    color: rgb(174, 247, 185);
    /* text-shadow: 2px 2px 6px rgba(0, 0, 0, 0.4); */
}

.hero-text {
    font-family: 'Heebo', 'Poppins', sans-serif;
    font-size: 18px;
    font-weight: 400;
    line-height: 1.6;
    max-width: 800px;
    margin: 0 0 30px 0;
    text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.3);
}

/* SearchBox dans le hero */
.hero-search-wrapper {
    width: 100%;
    max-width: 1000px;
    margin-top: 10px;
    padding: 25px;
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(10px);
    border-radius: 15px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
    border: 1px solid rgba(255, 255, 255, 0.3);
}

/* Responsive Hero Section */
@media (max-width: 1024px) {
    .hero-section {
        height: 650px;
    }
    
    .hero-search-wrapper {
        padding: 20px;
        max-width: 95%;
    }
}

@media (max-width: 768px) {
    .hero-section {
        height: 700px;
        margin-bottom: 1.5em;
    }
    
    .hero-title {
        font-size: 32px;
    }
    
    .hero-subtitle {
        font-size: 24px;
    }
    
    .hero-text {
        font-size: 16px;
        padding: 0 15px;
        margin-bottom: 20px;
    }
    
    .hero-content {
        padding: 30px 15px;
    }
    
    .hero-search-wrapper {
        padding: 15px;
        margin-top: 20px;
    }
}

@media (max-width: 480px) {
    .hero-section {
        height: auto;
        min-height: 650px;
        padding-bottom: 20px;
    }
    
    .hero-title {
        font-size: 26px;
        margin-bottom: 10px;
    }
    
    .hero-subtitle {
        font-size: 20px;
        margin-bottom: 15px;
    }
    
    .hero-text {
        font-size: 14px;
        margin-bottom: 15px;
    }
    
    .hero-search-wrapper {
        padding: 12px;
        margin-top: 15px;
        max-width: 98%;
    }
}

.btn-donar {
    margin-left: 2em;
    margin-right: 2em;
    margin-top: 1em;
    padding: 1em 2em;
    font-size: 1.3em;
}

.ios-safari-warning {
    color: red;
    font-weight: bold;
    margin-bottom: 0;
    font-size: 1.6em;
}

.ios-notification-warning {
    margin-top: 1em;
    padding: 1em;
    text-align: center;
    border: 2px solid orange;
    border-radius: 20px;
}

.ios-notification-warning h4 {
    margin-bottom: 0.5em;
}

.ios-notification-warning p {
    margin-bottom: 1em;
}

.notification-warning-buttons {
    display: flex;
    justify-content: center;
    gap: 10px;
    flex-wrap: wrap;
}

.notification-warning-buttons .btn {
    margin: 0;
}

@media (max-width: 768px) {
    .notification-warning-buttons {
        flex-direction: column;
        align-items: center;
    }
    
    .notification-warning-buttons .btn {
        margin-bottom: 10px;
        width: 100%;
        max-width: 200px;
    }
}

/* Section Comment ça marche */
.how-it-works-section {
    margin-top: 3rem;
    margin-bottom: 3rem;
    padding: 2rem 1rem;
}

.how-it-works-title {
    font-family: 'Poppins', sans-serif;
    font-size: 2.5rem;
    font-weight: 700;
    color: #2d5016;
    text-align: center;
    margin-bottom: 1rem;
}

.how-it-works-subtitle {
    font-family: 'Heebo', 'Poppins', sans-serif;
    font-size: 1.125rem;
    color: #666;
    text-align: center;
    max-width: 700px;
    margin: 0 auto 3rem;
    line-height: 1.6;
}

.how-it-works-cards {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 2rem;
    max-width: 1200px;
    margin: 0 auto;
}

.how-card {
    background: #ffffff;
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    padding: 2rem;
    text-align: center;
    transition: all 0.3s ease;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.how-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
}

.how-card-icon {
    width: 80px;
    height: 80px;
    margin: 0 auto 1.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    transition: transform 0.3s ease;
}

.how-card-icon i {
    font-size: 2.5rem;
}

.how-card:hover .how-card-icon {
    transform: scale(1.1);
}

.green-icon {
    background-color: #e8f5e9;
    color: #4caf50;
}

.how-card-title {
    font-family: 'Poppins', sans-serif;
    font-size: 1.5rem;
    font-weight: 600;
    color: #1f2937;
    margin-bottom: 1rem;
}

.how-card-description {
    font-family: 'Heebo', 'Poppins', sans-serif;
    font-size: 1rem;
    color: #6b7280;
    line-height: 1.6;
    margin: 0;
}

/* Responsive pour les cartes Comment ça marche */
@media (max-width: 1024px) {
    .how-it-works-cards {
        gap: 1.5rem;
    }
    
    .how-card {
        padding: 1.5rem;
    }
}

@media (max-width: 768px) {
    .how-it-works-section {
        padding: 1.5rem 1rem;
        margin-top: 2rem;
        margin-bottom: 2rem;
    }
    
    .how-it-works-title {
        font-size: 2rem;
    }
    
    .how-it-works-subtitle {
        font-size: 1rem;
        margin-bottom: 2rem;
    }
    
    .how-it-works-cards {
        grid-template-columns: 1fr;
        gap: 1.5rem;
    }
    
    .how-card {
        padding: 1.5rem;
    }
    
    .how-card-icon {
        width: 70px;
        height: 70px;
    }
    
    .how-card-icon i {
        font-size: 2.2rem;
    }
    
    .how-card-title {
        font-size: 1.25rem;
    }
    
    .how-card-description {
        font-size: 0.95rem;
    }
}

@media (max-width: 480px) {
    .how-it-works-title {
        font-size: 1.75rem;
    }
    
    .how-it-works-subtitle {
        font-size: 0.9rem;
        padding: 0 1rem;
    }
    
    .how-card {
        padding: 1.25rem;
    }
    
    .how-card-icon {
        width: 60px;
        height: 60px;
    }
    
    .how-card-icon i {
        font-size: 2rem;
    }
}

/* Section Pourquoi choisir MyEcoCar */
.why-choose-section {
    background: #c5eed6;
    margin: 1rem auto 3rem;
    padding: 1rem;
    width: 100vw;
    margin-left: calc(-50vw + 50%);
    margin-right: calc(-50vw + 50%);
}

.why-choose-title {
    font-family: 'Poppins', sans-serif;
    font-size: 2.25rem;
    font-weight: 700;
    color: #204d2d;
    text-align: center;
    margin: 0 0 0.75rem;
}

.why-choose-subtitle {
    font-family: 'Heebo', 'Poppins', sans-serif;
    font-size: 1.1rem;
    color: #4b5563;
    text-align: center;
    margin: 0 auto 2.2rem;
    max-width: 760px;
    line-height: 1.6;
}

.why-choose-row {
    display: grid;
    grid-template-columns: 1fr 1.6fr;
    gap: 1rem;
    align-items: stretch;
    max-width: 1300px;
    margin: 0 auto;
    padding: 0 2rem;
}

.why-choose-image-col {
    min-height: 100%;
}

.why-choose-image {
    width: 100%;
    height: 90%;
    min-height: 500px;
    object-fit: cover;
    border-radius: 10px;
    /* border: 1px solid #d9e6d5; */
    box-shadow: 0 12px 30px rgba(0, 0, 0, 0.12);
}

.why-choose-content-col {
    /* background: #effcf4; */
    /* border: 1px solid #d7eadb; */
    border-radius: 18px;
    padding: 1.5rem;
    display: grid;
    gap: 1rem;
}

.feature-item {
    display: grid;
    grid-template-columns: 56px 1fr;
    gap: 0.9rem;
    align-items: start;
}

.feature-icon {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    background: #dff2e3;
    color: #2f9e44;
    display: flex;
    align-items: center;
    justify-content: center;
}

.feature-icon i {
    font-size: 1.8rem;
}

.feature-title {
    font-family: 'Poppins', sans-serif;
    font-size: 1.25rem;
    font-weight: 600;
    color: #1f2937;
    margin: 0 0 0.5rem;
}

.feature-description {
    font-family: 'Heebo', 'Poppins', sans-serif;
    font-size: 1rem;
    color: #4b5563;
    margin: 0;
    line-height: 1.65;
}

@media (max-width: 1024px) {
    .why-choose-row {
        grid-template-columns: 1fr;
        padding: 0 1.5rem;
    }

    .why-choose-image {
        min-height: 320px;
        max-height: 420px;
    }
}

@media (max-width: 768px) {
    .why-choose-row {
        padding: 0 1rem;
    }

    .why-choose-title {
        font-size: 1.8rem;
    }

    .why-choose-subtitle {
        font-size: 1rem;
        margin-bottom: 1.5rem;
    }

    .why-choose-content-col {
        padding: 1.1rem;
    }

    .feature-item {
        grid-template-columns: 48px 1fr;
    }

    .feature-icon {
        width: 48px;
        height: 48px;
    }

    .feature-icon i {
        font-size: 1.4rem;
    }

    .feature-title {
        font-size: 1.1rem;
    }

    .feature-description {
        font-size: 0.95rem;
    }
}

/* Section Nos Partenaires */
.partners-section {
    margin: 4rem auto 3rem;
    padding: 2rem 1rem;
    max-width: 1200px;
}

.partners-title {
    font-family: 'Poppins', sans-serif;
    font-size: 2.5rem;
    font-weight: 700;
    color: #2d5016;
    text-align: center;
    margin: 0 0 1rem;
}

.partners-subtitle {
    font-family: 'Heebo', 'Poppins', sans-serif;
    font-size: 1.125rem;
    color: #666;
    text-align: center;
    max-width: 700px;
    margin: 0 auto 3rem;
    line-height: 1.6;
}

.partners-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 2rem;
    align-items: center;
    justify-items: center;
}

.partner-item {
    width: 100%;
    height: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ffffff;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    padding: 1.5rem;
    transition: all 0.3s ease;
}

.partner-item:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
    border-color: #4caf50;
}

.partner-placeholder {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    color: #9ca3af;
    transition: all 0.3s ease;
}

.partner-placeholder i {
    font-size: 2.5rem;
}

.partner-placeholder span {
    font-family: 'Poppins', sans-serif;
    font-size: 0.85rem;
    font-weight: 500;
}

.partner-item:hover .partner-placeholder {
    color: #4caf50;
}

.partner-logo {
    max-width: 100%;
    max-height: 80px;
    width: auto;
    height: auto;
    object-fit: contain;
    filter: grayscale(100%);
    opacity: 0.7;
    transition: all 0.3s ease;
}

.partner-item:hover .partner-logo {
    filter: grayscale(0%);
    opacity: 1;
}

/* Responsive pour la grille de partenaires */
@media (max-width: 1024px) {
    .partners-grid {
        grid-template-columns: repeat(3, 1fr);
        gap: 1.5rem;
    }
}

@media (max-width: 768px) {
    .partners-section {
        margin: 3rem auto 2rem;
        padding: 1.5rem 1rem;
    }

    .partners-title {
        font-size: 2rem;
    }

    .partners-subtitle {
        font-size: 1rem;
        margin-bottom: 2rem;
    }

    .partners-grid {
        grid-template-columns: repeat(2, 1fr);
        gap: 1.2rem;
    }

    .partner-item {
        height: 100px;
        padding: 1rem;
    }

    .partner-placeholder i {
        font-size: 2rem;
    }

    .partner-placeholder span {
        font-size: 0.75rem;
    }

    .partner-logo {
        max-height: 60px;
    }
}

@media (max-width: 480px) {
    .partners-title {
        font-size: 1.75rem;
    }

    .partners-subtitle {
        font-size: 0.9rem;
        padding: 0 1rem;
    }

    .partners-grid {
        grid-template-columns: repeat(2, 1fr);
        gap: 1rem;
    }

    .partner-item {
        height: 90px;
        padding: 0.8rem;
    }

    .partner-placeholder i {
        font-size: 1.8rem;
    }

    .partner-placeholder span {
        font-size: 0.7rem;
    }
}

/* Section Footer */
.footer-section {
    background: linear-gradient(135deg, #1f3f2e 0%, #2d5016 100%);
    color: #ffffff;
    width: 100vw;
    margin-left: calc(-50vw + 50%);
    margin-right: calc(-50vw + 50%);
    margin-top: 4rem;
    margin-bottom: 0 !important;
    padding: 3rem 1rem 0;
}

.footer-container {
    max-width: 1200px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: 0.8fr 1.2fr;
    gap: 3rem;
    align-items: start;
}

.footer-left {
    display: flex;
    flex-direction: column;
    gap: 2rem;
}

.footer-logo-section {
    display: flex;
    align-items: center;
    gap: 0.75rem;
}

.footer-logo {
    width: 50px;
    height: 50px;
    object-fit: contain;
}

.footer-brand-name {
    font-family: 'Poppins', sans-serif;
    font-size: 1.5rem;
    font-weight: 700;
    color: #aef7b9;
}

.footer-social-links {
    display: flex;
    gap: 1rem;
    align-items: center;
}

.social-link {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #aef7b9;
    text-decoration: none;
    transition: all 0.3s ease;
}

.social-link:hover {
    background: rgba(174, 247, 185, 0.2);
    color: #ffffff;
    transform: translateY(-3px);
}

.social-link i {
    font-size: 1.25rem;
}

.footer-center {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 2.5rem;
}

.footer-column {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.footer-column-title {
    font-family: 'Poppins', sans-serif;
    font-size: 1.1rem;
    font-weight: 600;
    color: #aef7b9;
    margin: 0;
}

.footer-links {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
}

.footer-links li {
    margin: 0;
}

.footer-links a {
    color: rgba(255, 255, 255, 0.8);
    text-decoration: none;
    font-family: 'Heebo', 'Poppins', sans-serif;
    font-size: 0.95rem;
    transition: color 0.3s ease;
}

.footer-links a:hover {
    color: #aef7b9;
    text-decoration: underline;
}

.footer-bottom {
    text-align: center;
    margin-top: 2rem;
    margin-bottom: 0;
    padding-top: 2rem;
    padding-bottom: 1.5rem;
    border-top: 1px solid rgba(174, 247, 185, 0.2);
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;
}

.footer-copyright {
    font-family: 'Heebo', 'Poppins', sans-serif;
    font-size: 0.9rem;
    color: rgba(255, 255, 255, 0.7);
    margin: 0;
}

/* Responsive Footer */
@media (max-width: 1024px) {
    .footer-container {
        grid-template-columns: 1fr;
        gap: 2rem;
    }

    .footer-center {
        grid-template-columns: repeat(3, 1fr);
        gap: 2rem;
    }
}

@media (max-width: 768px) {
    .footer-section {
        padding: 2rem 1rem 1rem;
        margin-top: 3rem;
    }

    .footer-left {
        gap: 1.5rem;
    }

    .footer-center {
        grid-template-columns: 1fr;
        gap: 1.5rem;
    }

    .footer-column {
        gap: 0.75rem;
    }

    .footer-column-title {
        font-size: 1rem;
    }

    .footer-links a {
        font-size: 0.9rem;
    }

    .footer-logo {
        width: 40px;
        height: 40px;
    }

    .footer-brand-name {
        font-size: 1.25rem;
    }
}

@media (max-width: 480px) {
    .footer-section {
        padding: 1.5rem 1rem;
        margin-top: 2rem;
    }

    .footer-logo {
        width: 35px;
        height: 35px;
    }

    .footer-brand-name {
        font-size: 1.1rem;
    }

    .footer-center {
        grid-template-columns: 1fr;
        gap: 1.2rem;
    }

    .footer-column-title {
        font-size: 0.95rem;
    }

    .footer-links a {
        font-size: 0.85rem;
    }

    .social-link {
        width: 40px;
        height: 40px;
    }

    .social-link i {
        font-size: 1.1rem;
    }
}
</style>
